import {
  Checkbox as MantineCheckbox,
  CheckboxCardProps as MantineCheckboxCardProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './CheckboxCard.module.css';

export type CheckboxCardProps = Omit<
  MantineCheckboxCardProps,
  'styles' | 'classNames' | 'unstyled'
>;

const CLASS_NAMES = { card: styles.card };

export const CheckboxCard = forwardRef<HTMLButtonElement, CheckboxCardProps>(
  (props, ref) => (
    <MantineCheckbox.Card
      ref={ref}
      unstyled
      classNames={CLASS_NAMES}
      {...props}
    />
  )
);

CheckboxCard.displayName = 'CheckboxCard';
